import React, { Component } from 'react';
//import ReactTable from "react-table"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
//import { DialogComponent } from '@syncfusion/ej2-react-popups';
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class AddHospitalAdmin extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAdminApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchHospitalAdminApi()
                this.setState({ disabled: false })
            }
        }];

        this.state = {
            language: null,
            // data: [
            //     {
            //         id: '',
            //         answer: '',
            //         originalQuestionId: '',
            //         // categoryTags: '',
            //         autoTranslate: '',
            //         alias: '',
            //     }
            // ],
            data : [],
            pageNum: null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            healthSystemId: '',
            paginationValue: 10,
            dummyUUID: "00000000-0000-0000-0000-000000000000",
            searchTerm: "",
            noMatchingData : false,
            isLoading : true,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var ansController = this;
        ansController.state.paginationValue = ansController.state.paginationValue + 5;
        if (ansController.state.pageNum != 0) {
            ansController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true,
            noMatchingData : false
        })
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no hospital admin present. </p>
        </div>
    );

    addAdminApi = (props, e) => {

        var thisController = this;

        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        //var contactNumberPattern = new RegExp(/^(?=.*\d).+$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );

        // new RegExp(/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/);
        // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);


        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        }
        else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        }
        else if (adminContactNumber.length > 17 || !contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        }
        else {
            $.ajax({
                url: "/my-jeeva-api/provider-admin",

                method: 'POST',
                data: {
                    role: "HOSPITAL_ADMIN",
                    userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                    userName: document.getElementById("adminName" + props.id).innerText.trim(),
                    userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim(),
                    healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                    hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")

                },
                success: function (res) {
                    if (res.success === true) {
                        // addAnswerController.setState({ hideAddDialog: true });
                        thisController.NotifyAdd();
                        thisController.state.disabled = false;
                        thisController.fetchHospitalAdminApi();
                    } else {
                        thisController.NotifyFailToLoad();
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Hospital Admin details has been added successfully</b>, {
            position: "top-center",

        });

    }

    notifyResponse(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateApi(props, e) {
        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var thisController = this
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        //var contactNumberPattern = new RegExp(/^(?=.*\d).+$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        // var namePattern = new RegExp(/([a-zA-Z\s])*$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);


        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        }
        else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        }
        else if (adminContactNumber.length > 17 || !contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        }
        else {
            var saveData = {
                id: props.id,
                hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"],
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                userRole: "HOSPITAL_ADMIN",
                userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                userName: document.getElementById("adminName" + props.id).innerText.trim(),
                userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim(),
                procedureId: this.state.dummyUUID,
                serviceLineId: this.state.dummyUUID,
            }

            $.ajax({
                url: "/my-jeeva-api/provider",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.fetchHospitalAdminApi();
                    } else {
                        if (res.result != "") {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                        else {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Hospital Admin details has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    deleteAdminApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'HOSPITAL_ADMIN',
                hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"],
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",

                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.state.data = [];
                        deleteConstructorVariables.setState(deleteConstructorVariables.state);
                        deleteConstructorVariables.fetchHospitalAdminApi();

                    } else {
                        if (res.result != "") {
                            deleteConstructorVariables.notifyFailToDelete(res.result);
                        }
                        deleteConstructorVariables.NotifyFailToLoad();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }
    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Hospital Admin detail has been deleted successfully</b>, {
            position: "top-center"
        });
    }

    nNotifyFailToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    refreshData = (id) => {
        this.setState({
            editedId: id,
            disabled: false,
            isLoading : true,
            searchTerm : "",
            data: []
        });
        this.fetchHospitalAdminApi();
    };


    fetchHospitalAdminApi = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/provider",

            method: 'GET',
            data: {
                hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"],
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                role: "HOSPITAL_ADMIN",
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    thisController.setState({
                        data: res.result,
                        disabled: false,
                        noMatchingData : false,
                        isLoading : false,
                    })
                }
                else {
                    thisController.setState({
                        noMatchingData : false,
                        isLoading : false,
                    })
                    // thisController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/login";
                }
            }
        });
    }

    componentDidMount() {

        setTimeout(() => {
            this.fetchHospitalAdminApi();
        }, 300);


    }
    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.userName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteAdminApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {

        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-admins-data",
            method: "GET",
            data: {
                hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"],
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                role: "HOSPITAL_ADMIN",
                searchTerm: thisController.state.searchTerm,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    render() {
        const { data } = this.state
        const columns = [

            {
                name: <b style={{ fontSize: '16px' }}>Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userName'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '4.5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminName" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userName}

                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Email ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userEmailId'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '4.5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminEmailId" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userEmailId}

                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Contact Number</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userPhoneNumber'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '4.5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminContactNumber" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userPhoneNumber}

                    </div>)
            },

            {
                name: <b style={{ fontSize: '16px' }}>Action</b>,
                width: 100,
                selector: (props) => (
                    <div id="action">
                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none",
                                marginTop: '-13px'
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                // title={(props.id == "") ||
                                //     (this.state.data[props.id].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.addAdminApi(props, e) :
                                        (props.id == this.state.editedId) ?
                                            this.updateApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '8px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.id) === '' ?
                                    this.fetchHospitalAdminApi() : this.openDeletePopUp(props)}
                            // this.setState({
                            //     hideDeletePopup: true, deletePropIndex: props.id,
                            //     propsId: props
                            // })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }} id='addHospitalAdminTab'>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="stylesheet" href="./assets/css/styles.css" />

                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">

                            <div >
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Hospital Admin</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "55vw", marginTop: "1vh" }}>
                                <input
                                    type="text"
                                    style={{
                                        width: "12vw",
                                        border: "2px solid #777676",
                                        borderRadius: "10px",
                                        padding: "10px",
                                        height: "0.7vw"
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                            </div>
                            {/* Add button */}
                            <div style={{ marginLeft: "3vw" }} Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                {!this.state.noMatchingData &&
                                    <div className="card"> 
                                    {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                          <p>Loading ...</p>
                                        </div>
                                      )}
                                      {!this.state.isLoading && this.state.data.length === 0 &&  (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                          <p>There are no hospital admin present.</p>
                                        </div>
                                      )}
                                      {(!this.state.isLoading && this.state.data.length > 0 ) && (
                    
                                            <DataTable
                                                data={this.state.data}
                                                columns={columns}
                                                pagination={this.state.paginationValue}
                                                fixedHeaderScrollHeight="400px"
                                                noDataComponent={<this.CustomNoDataComponent />}
                                            />
                                        )}
                                    </div>
    }
                                    <ToastContainer className="Toast-at-center" />
                                    <div className='card'>
                                        {this.state.noMatchingData &&
                                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                                <p>No matching options found ...</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default AddHospitalAdmin;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/AddHospitalAdmin.js